import ApiService from '@/services/api.service';

const TestOrderResultsService = {
    getAllListing(parameters) {
        return ApiService.getWithArray('/PatientTestResults/', parameters);
    },

    add(data) {
        return ApiService.post(`/PatientTestResults`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientTestResults/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientTestResults/${id}`, data);
    },

    getTestOrderFromPanelControl(code) {
        return ApiService.get(`/PatientTestResults/TestOrderFromPanel?Code=${code}`);
    },

    get(id) {
        return ApiService.get(`/PatientTestResults/${id}`);
    },

    getOrCreateFromTestOrderCode(id) {
        return ApiService.get(`/PatientTestResults/OrCreateFromTestOrderCode/${id}`);
    }
};

export default TestOrderResultsService;
